module.exports = __webpack_public_path__ + "static/img/79-1.64554c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/79-1.jpg
// module id = qZHO
// module chunks = 0